<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<cnHeader></cnHeader>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb"><a href="/cn/">首页</a><span class="space">/</span>攻略</div>
			</div>
			<!--面包屑与公共提醒-结束-->
		</div>
		
		<div class="pub_div guide_box">
			
			<div class="gb_left_box">
				<h1>攻略</h1>
				<ul>
					<li v-for="item in typeList" :key="item.TypeId" :class=" item.TypeId==typeId ?'selected':''" @click="changeType(item.TypeId)">{{item.TypeName}}</li>
				</ul>
			</div>
			
			<div class="gb_right_box">
				
				<ul>
					<li v-for="item in guideList" :key="item.Id">
						<a :href="'guide/detail?Id='+item.Id" target="_blank">{{item.Title}}</a>
					</li>
				</ul>
				
				<!--无数据-->
				<cnNoData :isShow="noDataIsShow"></cnNoData>
				
				<div class="page_ctrl" v-if="guideList.length>0 && pageTotal>1">
					<el-pagination layout="prev, pager, next" :total="recordTotal" :current-page="pageIndex"
						:pager-count="5" :page-size="pageSize" :background="true" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
				
			</div>
			
		</div>		
		
		<cnFooter></cnFooter>
	</div>
</template>

<script>
	import {
		getGuideTypeList,
		getGuideList,
		getGuideDetail
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import cnHeader from '@/components/cn_header.vue'
	import cnFooter from '@/components/cn_footer.vue'
	import cnNoData from '@/components/cn_noData.vue'
	export default {
		name: 'CN_Guide',
		mixins: [mixin],
		components: {
			cnHeader,
			cnFooter,
			cnNoData,
		},
		data() {
			return {
				language: 'cn', //语言版本
				Id: 0, //当前id
				typeId: 0, //分类Id，全部：0
				fullscreenLoading: true, //loading状态
				noDataIsShow: false, //无数据缺省
				typeList: [], //分类列表
				guideList: [], //数据列表
				pageIndex: 1, //页码，默认为1
				pageSize: 10, //每页显示条数
				pageTotal: 0, //总页数
				recordTotal: 0, //总条数
				guideDetail: {}, //详情
				
				guideContent: '',	//富文本详情
			}
		},
		created() {
			// 模拟获取url参数
			// this.typeId = this.$route.query.typeId
			// this.typeId += this.$route.query.sex
			this.getTypeList()
		},
		mounted() { //组件挂载到 DOM 后触发

		},
		methods: {
			//获取分类
			async getTypeList() {
				const {
					data: res
				} = await getGuideTypeList(this.language)
				if (res.errcode === 0) {
					this.typeList = res.data

					//获取分页数据
					this.getData()
				} else {
					this.$message.error(res.errmsg);
				}
			},
			// 获取数据
			async getData() {
				this.fullscreenLoading = true
				const {
					data: res
				} = await getGuideList(this.language, this.typeId, this.pageIndex)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.guideList = res.data.GuideList
					this.pageTotal = res.data.PageTotal
					this.recordTotal = res.data.RecordTotal
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			// 切换分类
			changeType(typeId) {
				this.fullscreenLoading = true
				this.typeId = typeId
				this.pageIndex = 1
				this.getData()
			},
			
			//查看详情
			async toDetail(Id) {
				this.fullscreenLoading = true
				this.Id = Id
				const {
					data: res
				} = await getGuideDetail(this.language, this.Id)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.guideDetail = res.data
					
					//热词替换
					this.guideContent = this.patchReplace(
					this.guideDetail.RecreationHotKeywords,
					this.guideDetail.Content,
					'/cn/recreation/detail?Id=')
					
					this.$nextTick(() => {
						window.scrollTo(0, 0);
					});
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//切换页码
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		.guide_box {
			margin-top: 40px;
			display: flex;
			justify-content: space-between;
			
			
			.gb_left_box {
				width: 250px;
				min-height: 650px;
				box-sizing: border-box;
				border-right: #e4e4e4 solid 1px;
				padding-bottom: 40px;
				
				h1 {
					font-size: 20px;
					font-weight: 500;
				}
				
				ul{
					margin-top: 30px;
					width: 86%;
				}
				li {
					font-size: 16px;
					line-height: 140%;
					padding: 8px 8px;
					border-bottom: #eee solid 1px;
					border: #fff solid 2px;
					background-color: #fff;
					border-radius: 8px;
					margin: 8px 0;
					cursor: pointer;
					-webkit-transition: all .3s ease;
				}
				li:hover {
					border: #3D7853 solid 2px;
				}
				li.selected {
					background-color: #fff;
					border: #3D7853 solid 2px;
					color: #3D7853;
					background-position: right 12px center;
					background-repeat: no-repeat;
					background-size: auto 12px;
					background-image: url(@/assets/images/hgh_arrow_right_gray.png);
				}
			}
			
			.gb_right_box {
				width: 1050px;
				
				h1 {
					font-size: 28px;
					font-weight: 500;
				}
				
				ul {
					// margin-top: 30px;
				}
				li {
					font-size: 16px;
					line-height: 140%;
					padding: 10px 0;
					list-style-type: disc;
				}
				li:hover {
					color: #3D7853;
				}
			}
			
		}
		
		.page_ctrl {
			margin: 40px 0;
		}
		
		/deep/ .el-pagination {
			font-size: 16px;
		}
		
		/deep/ .el-pager li {
			width: 36px;
			height: 36px;
			font-size: 16px;
			line-height: 36px;
			margin: 0 5px;
			border-radius: 5px;
		}
		
		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #3D7856;
			font-size: 16px;
		}
		
		/deep/ .el-pagination button {
			width: 36px;
			height: 36px;	
			border-radius: 5px;
		}
		
		/deep/ .el-pagination .btn-next .el-icon {
			font-size: 16px;
		}
		/deep/ .el-pagination .btn-prev .el-icon {			
			font-size: 16px;
		}
		
	}
</style>